module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_08.82c766d2.jpg";